/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseAdminDepositAmountRespVo,
  ResponseGetAdminUserWalletDetailListWithSummaryRespVo,
  ResponseListGetUserWalletOptionRespVo,
  ResponseListUserWalletInfoRespVo,
  ResponseLong,
  ResponsePageDataGetAdminUserWalletPageListRespVo,
  ResponsePageDataGetUserWalletDetailPageListRespVo,
  ResponsePageDataUserWalletHistoryListRespVo,
  ResponsePageDataUserWalletListRespVo,
  ResponseUserWalletInfoRespVo,
  UserWalletActionReqVo,
  UserWalletCreateReqVo,
  UserWalletFreezeActionReqVo,
  UserWalletHistoryCreateReqVo,
  UserWalletUnFreezeActionReqVo,
  UserWalletUpdateReqVo,
} from '../models/index';
import {
    ResponseAdminDepositAmountRespVoFromJSON,
    ResponseAdminDepositAmountRespVoToJSON,
    ResponseGetAdminUserWalletDetailListWithSummaryRespVoFromJSON,
    ResponseGetAdminUserWalletDetailListWithSummaryRespVoToJSON,
    ResponseListGetUserWalletOptionRespVoFromJSON,
    ResponseListGetUserWalletOptionRespVoToJSON,
    ResponseListUserWalletInfoRespVoFromJSON,
    ResponseListUserWalletInfoRespVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataGetAdminUserWalletPageListRespVoFromJSON,
    ResponsePageDataGetAdminUserWalletPageListRespVoToJSON,
    ResponsePageDataGetUserWalletDetailPageListRespVoFromJSON,
    ResponsePageDataGetUserWalletDetailPageListRespVoToJSON,
    ResponsePageDataUserWalletHistoryListRespVoFromJSON,
    ResponsePageDataUserWalletHistoryListRespVoToJSON,
    ResponsePageDataUserWalletListRespVoFromJSON,
    ResponsePageDataUserWalletListRespVoToJSON,
    ResponseUserWalletInfoRespVoFromJSON,
    ResponseUserWalletInfoRespVoToJSON,
    UserWalletActionReqVoFromJSON,
    UserWalletActionReqVoToJSON,
    UserWalletCreateReqVoFromJSON,
    UserWalletCreateReqVoToJSON,
    UserWalletFreezeActionReqVoFromJSON,
    UserWalletFreezeActionReqVoToJSON,
    UserWalletHistoryCreateReqVoFromJSON,
    UserWalletHistoryCreateReqVoToJSON,
    UserWalletUnFreezeActionReqVoFromJSON,
    UserWalletUnFreezeActionReqVoToJSON,
    UserWalletUpdateReqVoFromJSON,
    UserWalletUpdateReqVoToJSON,
} from '../models/index';

export interface UserWalletAddPostRequest {
    id: number;
    amount: string;
    content?: string;
}

export interface UserWalletAddReducePostRequest {
    id: number;
    amount: string;
    intOutType: number;
    content?: string;
}

export interface UserWalletAdminDetailListGetRequest {
    currentPage: number;
    pageSize: number;
    startTime?: string;
    endTime?: string;
    usedType?: number;
    walletType?: number;
    id?: number;
    name?: string;
    code?: string;
    remark?: string;
}

export interface UserWalletAdminExportGetRequest {
    name?: string;
    code?: string;
}

export interface UserWalletAdminPageListGetRequest {
    currentPage: number;
    pageSize: number;
    name?: string;
    code?: string;
}

export interface UserWalletDetailListGetRequest {
    currentPage: number;
    pageSize: number;
    usedType?: number;
    walletType?: number;
    billCode?: string;
    orderCode?: string;
}

export interface UserWalletFreezePostRequest {
    userWalletFreezeActionReqVo?: UserWalletFreezeActionReqVo;
}

export interface UserWalletHistoryIdDeleteRequest {
    id: number;
}

export interface UserWalletHistoryListGetRequest {
    currentPage: number;
    pageSize: number;
    keyword?: string;
    userId?: number;
    currencyCode?: string;
    walletId?: number;
    walletType?: number;
    intOutType?: number;
    enable?: number;
    startTime?: string;
    endTime?: string;
}

export interface UserWalletHistoryPostRequest {
    userWalletHistoryCreateReqVo?: UserWalletHistoryCreateReqVo;
}

export interface UserWalletIdDeleteRequest {
    id: number;
}

export interface UserWalletIdGetRequest {
    id: number;
}

export interface UserWalletIdPutRequest {
    id: number;
    userWalletUpdateReqVo?: UserWalletUpdateReqVo;
}

export interface UserWalletListGetRequest {
    currentPage: number;
    pageSize: number;
    keyword?: string;
    userId?: number;
    memberName?: string;
    memberCode?: string;
    currencyCode?: string;
    enable?: number;
    walletType?: number;
    startTime?: string;
    endTime?: string;
}

export interface UserWalletPostRequest {
    userWalletCreateReqVo?: UserWalletCreateReqVo;
}

export interface UserWalletSubPostRequest {
    userWalletActionReqVo?: UserWalletActionReqVo;
}

export interface UserWalletUnfreezePostRequest {
    userWalletUnFreezeActionReqVo?: UserWalletUnFreezeActionReqVo;
}

export interface UserWalletUserUserIdGetRequest {
    userId: number;
}

/**
 * 
 */
export class UserWalletControllerApi extends runtime.BaseAPI {

    /**
     * 用户钱包加余额 用户钱包加余额
     * 用户钱包加余额
     */
    async userWalletAddPostRaw(requestParameters: UserWalletAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userWalletAddPost().'
            );
        }

        if (requestParameters['amount'] == null) {
            throw new runtime.RequiredError(
                'amount',
                'Required parameter "amount" was null or undefined when calling userWalletAddPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['amount'] != null) {
            queryParameters['amount'] = requestParameters['amount'];
        }

        if (requestParameters['content'] != null) {
            queryParameters['content'] = requestParameters['content'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 用户钱包加余额 用户钱包加余额
     * 用户钱包加余额
     */
    async userWalletAddPost(requestParameters: UserWalletAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 用户钱包余额充值|扣费
     * 用户钱包余额充值|扣费
     */
    async userWalletAddReducePostRaw(requestParameters: UserWalletAddReducePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userWalletAddReducePost().'
            );
        }

        if (requestParameters['amount'] == null) {
            throw new runtime.RequiredError(
                'amount',
                'Required parameter "amount" was null or undefined when calling userWalletAddReducePost().'
            );
        }

        if (requestParameters['intOutType'] == null) {
            throw new runtime.RequiredError(
                'intOutType',
                'Required parameter "intOutType" was null or undefined when calling userWalletAddReducePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['amount'] != null) {
            queryParameters['amount'] = requestParameters['amount'];
        }

        if (requestParameters['content'] != null) {
            queryParameters['content'] = requestParameters['content'];
        }

        if (requestParameters['intOutType'] != null) {
            queryParameters['intOutType'] = requestParameters['intOutType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/add-reduce`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 用户钱包余额充值|扣费
     * 用户钱包余额充值|扣费
     */
    async userWalletAddReducePost(requestParameters: UserWalletAddReducePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletAddReducePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 预存款使用明细分页列表 预存款使用明细分页列表（含入金/出金总额统计）
     * 预存款使用明细分页列表
     */
    async userWalletAdminDetailListGetRaw(requestParameters: UserWalletAdminDetailListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetAdminUserWalletDetailListWithSummaryRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userWalletAdminDetailListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userWalletAdminDetailListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['usedType'] != null) {
            queryParameters['usedType'] = requestParameters['usedType'];
        }

        if (requestParameters['walletType'] != null) {
            queryParameters['walletType'] = requestParameters['walletType'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['remark'] != null) {
            queryParameters['remark'] = requestParameters['remark'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/admin/detail/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetAdminUserWalletDetailListWithSummaryRespVoFromJSON(jsonValue));
    }

    /**
     * 预存款使用明细分页列表 预存款使用明细分页列表（含入金/出金总额统计）
     * 预存款使用明细分页列表
     */
    async userWalletAdminDetailListGet(requestParameters: UserWalletAdminDetailListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetAdminUserWalletDetailListWithSummaryRespVo> {
        const response = await this.userWalletAdminDetailListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 预存款余额下载
     * 预存款余额下载
     */
    async userWalletAdminExportGetRaw(requestParameters: UserWalletAdminExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/admin/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 预存款余额下载
     * 预存款余额下载
     */
    async userWalletAdminExportGet(requestParameters: UserWalletAdminExportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.userWalletAdminExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ------管理端----- 管理端预存款管理分页列表
     * 管理端预存款管理分页列表
     */
    async userWalletAdminPageListGetRaw(requestParameters: UserWalletAdminPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataGetAdminUserWalletPageListRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userWalletAdminPageListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userWalletAdminPageListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/admin/page-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataGetAdminUserWalletPageListRespVoFromJSON(jsonValue));
    }

    /**
     * ------管理端----- 管理端预存款管理分页列表
     * 管理端预存款管理分页列表
     */
    async userWalletAdminPageListGet(requestParameters: UserWalletAdminPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataGetAdminUserWalletPageListRespVo> {
        const response = await this.userWalletAdminPageListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端获取预存款总金额 返回全部预存款余额总计，以及中国/韩国钱包分项总计
     * 管理端获取预存款总金额
     */
    async userWalletAdminTotalGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminDepositAmountRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/admin/total`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminDepositAmountRespVoFromJSON(jsonValue));
    }

    /**
     * 管理端获取预存款总金额 返回全部预存款余额总计，以及中国/韩国钱包分项总计
     * 管理端获取预存款总金额
     */
    async userWalletAdminTotalGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminDepositAmountRespVo> {
        const response = await this.userWalletAdminTotalGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * -----为客户端提供接口---- 获取当前登录用户预存款余额信息 获取当前登录用户名下全部钱包（中韩双钱包）余额信息，韩国在前、中国在后
     * 获取当前登录用户预存款余额信息
     */
    async userWalletCurrentGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListUserWalletInfoRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListUserWalletInfoRespVoFromJSON(jsonValue));
    }

    /**
     * -----为客户端提供接口---- 获取当前登录用户预存款余额信息 获取当前登录用户名下全部钱包（中韩双钱包）余额信息，韩国在前、中国在后
     * 获取当前登录用户预存款余额信息
     */
    async userWalletCurrentGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListUserWalletInfoRespVo> {
        const response = await this.userWalletCurrentGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 预存款明细列表(分页)
     * 预存款明细列表(分页)
     */
    async userWalletDetailListGetRaw(requestParameters: UserWalletDetailListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataGetUserWalletDetailPageListRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userWalletDetailListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userWalletDetailListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['usedType'] != null) {
            queryParameters['usedType'] = requestParameters['usedType'];
        }

        if (requestParameters['walletType'] != null) {
            queryParameters['walletType'] = requestParameters['walletType'];
        }

        if (requestParameters['billCode'] != null) {
            queryParameters['billCode'] = requestParameters['billCode'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/detail/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataGetUserWalletDetailPageListRespVoFromJSON(jsonValue));
    }

    /**
     * 预存款明细列表(分页)
     * 预存款明细列表(分页)
     */
    async userWalletDetailListGet(requestParameters: UserWalletDetailListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataGetUserWalletDetailPageListRespVo> {
        const response = await this.userWalletDetailListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 冻结金额 冻结金额 冻结用户钱包金额
     * 冻结金额
     */
    async userWalletFreezePostRaw(requestParameters: UserWalletFreezePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/freeze`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserWalletFreezeActionReqVoToJSON(requestParameters['userWalletFreezeActionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 冻结金额 冻结金额 冻结用户钱包金额
     * 冻结金额
     */
    async userWalletFreezePost(requestParameters: UserWalletFreezePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletFreezePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 钱包流水数据删除 钱包流水数据删除
     * 钱包流水数据删除
     */
    async userWalletHistoryIdDeleteRaw(requestParameters: UserWalletHistoryIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userWalletHistoryIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/history/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 钱包流水数据删除 钱包流水数据删除
     * 钱包流水数据删除
     */
    async userWalletHistoryIdDelete(requestParameters: UserWalletHistoryIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletHistoryIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 钱包流水信息列表查询(分页) 钱包流水信息列表查询(分页)
     * 钱包流水信息列表查询(分页)
     */
    async userWalletHistoryListGetRaw(requestParameters: UserWalletHistoryListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataUserWalletHistoryListRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userWalletHistoryListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userWalletHistoryListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['currencyCode'] != null) {
            queryParameters['currencyCode'] = requestParameters['currencyCode'];
        }

        if (requestParameters['walletId'] != null) {
            queryParameters['walletId'] = requestParameters['walletId'];
        }

        if (requestParameters['walletType'] != null) {
            queryParameters['walletType'] = requestParameters['walletType'];
        }

        if (requestParameters['intOutType'] != null) {
            queryParameters['intOutType'] = requestParameters['intOutType'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/history/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataUserWalletHistoryListRespVoFromJSON(jsonValue));
    }

    /**
     * 钱包流水信息列表查询(分页) 钱包流水信息列表查询(分页)
     * 钱包流水信息列表查询(分页)
     */
    async userWalletHistoryListGet(requestParameters: UserWalletHistoryListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataUserWalletHistoryListRespVo> {
        const response = await this.userWalletHistoryListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 钱包流水数据创建 钱包流水数据创建
     * 钱包流水数据创建
     */
    async userWalletHistoryPostRaw(requestParameters: UserWalletHistoryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserWalletHistoryCreateReqVoToJSON(requestParameters['userWalletHistoryCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 钱包流水数据创建 钱包流水数据创建
     * 钱包流水数据创建
     */
    async userWalletHistoryPost(requestParameters: UserWalletHistoryPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletHistoryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 删除钱包信息 删除钱包信息 删除指定钱包编号的钱包信息
     * 删除钱包信息
     */
    async userWalletIdDeleteRaw(requestParameters: UserWalletIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userWalletIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 删除钱包信息 删除钱包信息 删除指定钱包编号的钱包信息
     * 删除钱包信息
     */
    async userWalletIdDelete(requestParameters: UserWalletIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定数据编号,获取钱包信息 指定数据编号获取钱包信息
     * 指定数据编号获取钱包信息
     */
    async userWalletIdGetRaw(requestParameters: UserWalletIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserWalletInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userWalletIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserWalletInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定数据编号,获取钱包信息 指定数据编号获取钱包信息
     * 指定数据编号获取钱包信息
     */
    async userWalletIdGet(requestParameters: UserWalletIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserWalletInfoRespVo> {
        const response = await this.userWalletIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改钱包信息 修改钱包信息 更新指定钱包编号的钱包信息
     * 修改钱包信息
     */
    async userWalletIdPutRaw(requestParameters: UserWalletIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userWalletIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserWalletUpdateReqVoToJSON(requestParameters['userWalletUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 修改钱包信息 修改钱包信息 更新指定钱包编号的钱包信息
     * 修改钱包信息
     */
    async userWalletIdPut(requestParameters: UserWalletIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 钱包信息列表(分页) 钱包信息列表(分页)
     * 钱包信息列表(分页)
     */
    async userWalletListGetRaw(requestParameters: UserWalletListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataUserWalletListRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userWalletListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userWalletListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['memberName'] != null) {
            queryParameters['memberName'] = requestParameters['memberName'];
        }

        if (requestParameters['memberCode'] != null) {
            queryParameters['memberCode'] = requestParameters['memberCode'];
        }

        if (requestParameters['currencyCode'] != null) {
            queryParameters['currencyCode'] = requestParameters['currencyCode'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['walletType'] != null) {
            queryParameters['walletType'] = requestParameters['walletType'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataUserWalletListRespVoFromJSON(jsonValue));
    }

    /**
     * 钱包信息列表(分页) 钱包信息列表(分页)
     * 钱包信息列表(分页)
     */
    async userWalletListGet(requestParameters: UserWalletListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataUserWalletListRespVo> {
        const response = await this.userWalletListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 创建钱包信息 创建钱包信息 为新用户创建钱包
     * 创建钱包信息
     */
    async userWalletPostRaw(requestParameters: UserWalletPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserWalletCreateReqVoToJSON(requestParameters['userWalletCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 创建钱包信息 创建钱包信息 为新用户创建钱包
     * 创建钱包信息
     */
    async userWalletPost(requestParameters: UserWalletPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 用户钱包减余额 用户钱包减余额
     * 用户钱包减余额
     */
    async userWalletSubPostRaw(requestParameters: UserWalletSubPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/sub`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserWalletActionReqVoToJSON(requestParameters['userWalletActionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 用户钱包减余额 用户钱包减余额
     * 用户钱包减余额
     */
    async userWalletSubPost(requestParameters: UserWalletSubPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletSubPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 解冻金额 解冻金额 解冻用户钱包金额
     * 解冻金额
     */
    async userWalletUnfreezePostRaw(requestParameters: UserWalletUnfreezePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/unfreeze`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserWalletUnFreezeActionReqVoToJSON(requestParameters['userWalletUnFreezeActionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 解冻金额 解冻金额 解冻用户钱包金额
     * 解冻金额
     */
    async userWalletUnfreezePost(requestParameters: UserWalletUnfreezePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userWalletUnfreezePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 预存款使用明细-使用区分-筛选项
     * 预存款使用明细-使用区分-筛选项
     */
    async userWalletUsageOptionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetUserWalletOptionRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/usage-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetUserWalletOptionRespVoFromJSON(jsonValue));
    }

    /**
     * 预存款使用明细-使用区分-筛选项
     * 预存款使用明细-使用区分-筛选项
     */
    async userWalletUsageOptionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetUserWalletOptionRespVo> {
        const response = await this.userWalletUsageOptionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 指定用户编号,查询用户钱包金额 查询用户钱包金额 指定用户ID,查询用户钱包金额
     * 查询用户钱包金额
     */
    async userWalletUserUserIdGetRaw(requestParameters: UserWalletUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserWalletInfoRespVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userWalletUserUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-wallet/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserWalletInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定用户编号,查询用户钱包金额 查询用户钱包金额 指定用户ID,查询用户钱包金额
     * 查询用户钱包金额
     */
    async userWalletUserUserIdGet(requestParameters: UserWalletUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserWalletInfoRespVo> {
        const response = await this.userWalletUserUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
